<template>
  <a-layout class='index animated fadeIn'>
    <a-card :bordered='false'>
      <a-form :model="formState" :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-form-item label="自动加入黑名单" required>
          <a-switch :checkedValue="1" :unCheckedValue="0" v-model:checked="formState.is_auto_shielding" />
          <!-- 自动加黑名单关闭则隐藏 -->
          <div v-if="formState.is_auto_shielding">
            每日首次扫码次数满
            <a-input-number v-model:value="formState.day_scan_count" :precision="0" /> 次，拉黑
            <a-input-number v-model:value="formState.scan_limint_expriy" :precision="0" /> 小时
            <div class="s_flex m-t-10">
              <div>扫码提示：</div><a-textarea v-model:value="formState.scan_shielding_tips" showCount :maxlength="100" style="width:310px"/>
            </div>
            <div class="s_flex_ali">
             <a-checkbox v-model:checked="formState.is_permanent_shielding" ></a-checkbox>
             <span class="m-l-5 m-r-5">每</span>
             <a-select  style="width:80px" size="small" v-model:value="formState.permanent_unit">
                <a-select-option :value="1" selected>日</a-select-option>
                <a-select-option :value="2">周</a-select-option>
                <a-select-option :value="3">月</a-select-option>
                <a-select-option :value="4">季</a-select-option>
              </a-select>
             <span class="m-l-5 m-r-5">拉黑</span>
             <a-input-number v-model:value="formState.permanent_scan_count" :precision="0" /><span class="m-l-5">次,永久拉黑。</span>
            </div>
              <div class="s_flex m-t-10">
              <div>扫码提示：</div><a-textarea v-model:value="formState.permanent_shielding_tips " showCount :maxlength="100" style="width:310px"/>
            </div>
          </div>
        </a-form-item>
        <a-form-item label="手动加入黑名单" name="manual_shielding_tips"  :wrapperCol="{span:7}">
          <a-textarea v-model:value="formState.manual_shielding_tips" showCount :maxlength="100" style="width:380px" />
        </a-form-item>
        <a-form-item :wrapper-col="{ span: 14, offset: 3 }">
          <a-button type="primary" v-has:scanBackSetSubmit="onSubmit">保存设置</a-button>
        </a-form-item>
      </a-form>
    </a-card>
  </a-layout>
</template>
<script>
import { defineComponent, onMounted,  ref } from "vue";
import {blacklistsConfig,blacklistsUpdateConfig} from '@/api/qrcode'
import { iscode } from "../../../utils/app";
import { message } from "ant-design-vue";
export default defineComponent({
  setup() {
    const formState = ref({});
    const initData=async()=>{
      let result=await blacklistsConfig().then(res=>res.data).catch(error=>error)
      if(iscode(result)){
        formState.value=result.data
      }else{
        message.error(result.message)
      }
    }
    const onSubmit = async() => {
      var json={}
      for (const key in formState.value) {
          if(formState.value[key]===true){
              json[key]=1
          }else  if(formState.value[key]===false){
              json[key]=0
          }else{
              json[key]=formState.value[key]
          }
      }
     let result=await blacklistsUpdateConfig(json).then(res=>res.data).catch(error=>error)
     iscode(result,true)
    };
      onMounted(()=>{
        initData()
      })
    return {
      labelCol: {
        span: 3,
      },
      wrapperCol: {
        span: 20,
      },
      formState,
      onSubmit,
    };
  },
});
</script>